if (!customElements.get('sticky-atc-bar')) {
  class StickyAtcBar extends HTMLElement {
    constructor() {
      super();
      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.handleClose = this.handleClose.bind(this);
      this.handleBuyNow = this.handleBuyNow.bind(this);
      this.handleVariantSelect = this.handleVariantSelect.bind(this);
      this.handlePageShow = this.handlePageShow.bind(this);
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.bar = this.closest('.sticky-atc-bar');
      this.closeBtn = this.querySelector('.sticky-close-button');
      this.button = this.querySelector('.button-add-card');
      this.select = this.querySelector('.atc-bar-product__select');
      this.variantInput = this.querySelector('input[name="id"]');
      this.quantityInput = this.querySelector('input[name="quantity"]');
      this.price = this.querySelector('.price');
      this.image = this.querySelector('.atc-bar-product__img');
      this.productInfo = document.querySelector('.product .product__info-wrapper');
      this.closedManually = false;

      if (this.closeBtn) this.closeBtn.addEventListener('click', this.handleClose);
      if (this.button) this.button.addEventListener('click', this.handleBuyNow);
      if (this.select) this.select.addEventListener('change', this.handleVariantSelect);

      document.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize);
      window.addEventListener('pageshow', this.handlePageShow);

      this.syncFromCurrentState();
      this.handleScroll();
    }

    disconnectedCallback() {
      document.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('pageshow', this.handlePageShow);

      if (this.closeBtn) this.closeBtn.removeEventListener('click', this.handleClose);
      if (this.button) this.button.removeEventListener('click', this.handleBuyNow);
      if (this.select) this.select.removeEventListener('change', this.handleVariantSelect);
    }

    handleResize() {
      this.productInfo = document.querySelector('.product .product__info-wrapper');
      this.handleScroll();
    }

    handlePageShow() {
      if (!this.button || this.button.dataset.soldOutLabel === this.button.querySelector('.sticky-atc-bar__button-label')?.textContent) {
        return;
      }

      this.button.removeAttribute('disabled');
    }

    handleScroll() {
      if (!this.bar || !this.productInfo) return;

      const triggerTop = this.productInfo.getBoundingClientRect().bottom + window.scrollY;
      const shouldShow = window.scrollY > triggerTop;

      if (shouldShow && !this.closedManually) {
        this.bar.classList.add('atc-visible');
      } else {
        this.bar.classList.remove('atc-visible');
      }
    }

    handleClose(event) {
      event.preventDefault();
      event.stopPropagation();
      this.closedManually = true;
      if (this.bar) this.bar.classList.remove('atc-visible');
    }

    handleBuyNow(event) {
      event.preventDefault();
      if (!this.button || this.button.hasAttribute('disabled')) return;

      const variantId = this.getCurrentVariantId();
      if (!variantId) return;

      const quantity = this.quantityInput ? Math.max(parseInt(this.quantityInput.value, 10) || 1, 1) : 1;
      this.button.setAttribute('disabled', 'disabled');
      window.location.href = `/cart/${variantId}:${quantity}`;
    }

    handleVariantSelect(event) {
      const variantId = event.target.value;
      if (!variantId) return;

      if (this.variantInput) this.variantInput.value = variantId;
      this.renderProductInfo(variantId);
    }

    getCurrentVariantId() {
      if (this.variantInput && this.variantInput.value) return this.variantInput.value;
      if (this.select && this.select.value) return this.select.value;

      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('variant');
    }

    syncFromCurrentState() {
      const variantId = this.getCurrentVariantId();
      if (!variantId) return;

      if (this.select) this.select.value = variantId;
    }

    renderProductInfo(variantId) {
      fetch(`${this.dataset.url}?variant=${variantId}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const addButtonUpdated = html.querySelector('.main-product .product-form__submit');
          const priceHtml = html.querySelector('.product__info-wrapper .price');
          const featuredImage = html.querySelector('.product__media img');

          this.toggleButtonState(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true);

          if (priceHtml && this.price) {
            const duplicatePrice = priceHtml.cloneNode(true);
            this.price.replaceWith(duplicatePrice);
            this.price = duplicatePrice;
          }

          if (featuredImage && this.image) {
            this.image.src = featuredImage.currentSrc || featuredImage.src;
            this.image.alt = featuredImage.alt || this.image.alt;
          }
        })
        .catch((error) => {
          console.error('Sticky add to cart sync failed:', error);
        });
    }

    toggleButtonState(disable) {
      if (!this.button) return;

      const label = this.button.querySelector('.sticky-atc-bar__button-label');
      if (disable) {
        this.button.setAttribute('disabled', 'disabled');
        if (label) label.textContent = this.button.dataset.soldOutLabel || window.variantStrings.soldOut;
        return;
      }

      this.button.removeAttribute('disabled');
      if (label) label.textContent = this.button.dataset.availableLabel || 'BUY NOW';
    }
  }

  customElements.define('sticky-atc-bar', StickyAtcBar);
}
